import { useState } from "react";
import axios from "axios";
import { CgClose } from "react-icons/cg";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "../../../../../../../../../api";

const ConfirmRecrutementModal = ({ show =false,  applicationId, onClose, onUpdate }) => {
  const [message, setMessage] = useState("Félicitations, vous avez été recruté pour cette offre !"); // Valeur par défaut
  const [loading, setLoading] = useState(false);

  // Fonction de mise à jour du statut
  const handleRecruitNow = async () => {
    setLoading(true);
    // try {
      // Mise à jour de la candidature
      await axios.post(`${api}/applications/${applicationId}/hire`, {
        status: "Recruté",
        message,
      })

    //   // Envoi de l'email
    //   await axios.post("${api}/send-email", {
    //     to: "email-du-candidat@example.com", // Remplacez par l'email du candidat
    //     subject: "Confirmation de recrutement",
    //     body: message,
    //   })
      .then((response)=>{
        console.log(response.data)
        onUpdate(); // Rafraîchir les données après mise à jour
        onClose(); // Fermer le modal
      }).catch ((error)=> {
      console.error("Erreur lors de la mise à jour ou de l'envoi de l'email :", error);
    }).finally (()=>{
      setLoading(false);
    })
  };

  return (
    <AnimatePresence>
    {show && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm"
      >
        <motion.div
          initial={{ opacity: 0, right: "-100%", y: 20 }}
          animate={{ opacity: 1, right: 0, y: 0 }}
          exit={{ opacity: 0, right: "-100%", y: 20 }}
          transition={{ type: "spring", stiffness: 130, damping: 20 }}
          className="fixed overflow-y-auto bg-white w-full lg:w-2/3 xl:w-1/2 min-h-full lg:rounded-s-2xl drop-shadow-lg"
        >
    {/* Header */}
    <div className="flex justify-between py-4 border-b px-6">
      <h4 className="text-lg font-bold">Planifier un entretien</h4>
      <button onClick={onClose}>
        <CgClose />
      </button>
    </div>

      <div className="p-4">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="h-96 border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
          placeholder="Message pour le candidat..."
        />

        <div className="flex justify-end space-x-4 mt-3">
          <button
            onClick={() => onClose()}
            className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
          >
            Annuler
          </button>
          <button
            onClick={handleRecruitNow}
            className="text-white bg-green-600 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
            disabled={loading}
          >
            {loading ? "En cours..." : "Recruter maintenant"}
          </button>
        </div>
      </div>
   
    </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
  );
};

export default ConfirmRecrutementModal;
